import { OktaAuth } from "@okta/okta-auth-js";

const LOGIN_CALLBACK_PATH = "login/callback";

let _oktaAuth: OktaAuth | null = null;

function getOktaAuth(): OktaAuth {
  if (!_oktaAuth) {
    _oktaAuth = new OktaAuth({
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
      issuer: import.meta.env.VITE_OKTA_ISSUER,
      redirectUri: `${document.location.origin}/${LOGIN_CALLBACK_PATH}`,
      scopes: ["openid", "profile", "email"],
      pkce: true,
    });
  }
  return _oktaAuth;
}

function getAccessToken(): string | undefined {
  return getOktaAuth().getAccessToken();
}

export { getOktaAuth, getAccessToken, LOGIN_CALLBACK_PATH };
